export default __webpack_public_path__ + "static/media/880521486740357170.7bb701c8.png";